
import CreateJobFamilyForm from "../../components/Forms/CreateJobFamilyForm";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";





function CreateJobFamily() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <CreateJobFamilyForm/>
            </BasicCard>
        </>
    )
}
export default CreateJobFamily;